import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "../Technology/AllBanner/DatabaseBanner.css";
import "../Services/mobileAppBanner.css";
import "../Services/mobileAppBanner.css";
import { Link } from "react-router-dom";

const MobileAppBanner = () => {
  const bannerImages = [
    { id: 1, imgUrl: "https://i.ibb.co/7JDvjqZx/Size-lg-1.png" },
    { id: 2, imgUrl: "https://i.ibb.co/wrL856Z2/Size-lg-2.png" },
    { id: 3, imgUrl: "https://i.ibb.co.com/fGSW9MdN/Size-lg-3.png" },
    { id: 4, imgUrl: "https://i.ibb.co/tpXhw4cq/Size-lg-4.png" },
  ];

  const mobileBannerImages = [
    {
      id: 1,
      imgUrl: "https://i.ibb.co.com/LdZZtS98/Image-Div-4.png",
      tittle: "Custom mobile app development",
      des: "Our Custom Mobile App Development services offers end-to-end solutions, from initial concept to deployment. We craft tailored iOS and Android apps with seamless functionality, intuitive design, and a focus on your business goals.",
    },
    {
      id: 2,
      imgUrl: "https://i.ibb.co.com/pv0rwhKt/Image-Div-2.png",
      tittle: "IOS App Development",
      des: "Our Custom Mobile App Development services offers end-to-end solutions, from initial concept to deployment. We craft tailored iOS and Android apps with seamless functionality, intuitive design, and a focus on your business goals.",
    },
    {
      id: 3,
      imgUrl: "https://i.ibb.co.com/tPnxbhX7/Image-Div-1.png",
      tittle: "Cross-Platform App Development",
      des: "Our cross-platform app development service enables seamless creation of mobile applications for iOS and Android devices, with experienced cross-platform mobile app developers optimizing performance and user experience.",
    },
    {
      id: 4,
      imgUrl: "https://i.ibb.co.com/qFPvTqjX/Image-Div-3.png",
      tittle: "Android App Development",
      des: "Our Android App Development service offers custom solutions using technologies like Java, Kotlin, and Flutter. From concept to launch, we build feature-rich, intuitive Android apps designed to deliver seamless performance and align perfectly with your objectives.",
    },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % bannerImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bannerImages.length]);

  const nextIndex = (index + 1) % bannerImages.length;

  return (
    <div
      className="mob-app-head"
      style={{
        backgroundColor: "",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
      }}
    >
      {/* ===== HEADER ===== */}
      <div
        className="d-flex flex-column  justify-content-center align-items-center text-center"
        style={{
          height: "100%",
          position: "relative",
          zIndex: 2,
          maxWidth: "800px",
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <h1 style={{ fontWeight: "600" }} className="database-heading">
          Mobile Apps People Actually Keep Using
        </h1>
        <p className="database-text">
          Most mobile apps quietly fail. These get downloaded, opened one or two
          times and forgotten. We develop mobile applications by starting where
          users typically quit. At Quad Theory Ltd, mobile app development
          starts with actual behaviour, slow networks and small screens and
          distracted users.
        </p>

        <Link to="/contact-us">
          <motion.button
            type="button"
            className="data-button rounded-pill px-5 py-3"
            initial={{
              backgroundColor: "#19BDDE",
              boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
            }}
            whileHover={{
              backgroundColor: "#12869E",

              boxShadow: "none",
            }}
            transition={{ duration: 0.2 }}
            style={{
              border: "none",
              color: "#fff",
              fontWeight: "500",
              zIndex: 5,
              fontSize: "2rem",
            }}
          >
            Get Started
          </motion.button>
        </Link>
      </div>

      {/* ===== DESKTOP IMAGE SECTION ===== */}
      <div
        className="d-none d-lg-flex justify-content-center align-items-center"
        style={{
          position: "relative",
          transition: "all 0.3s ease",
        }}
      >
        {/* Background image */}
        <img
          className="mobile-image-one"
          src={bannerImages[nextIndex].imgUrl}
          alt="background"
        />

        {/* Foreground (main) image */}
        <img
          src={bannerImages[index].imgUrl}
          alt="visible"
          className="img-fluid mobile-image-two"
        />
      </div>

      {/* ===== SLIDER DOTS ===== */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        {bannerImages.map((_, i) => (
          <button
            className="d-none  mobile-dot-one d-lg-flex"
            key={i}
            onClick={() => setIndex(i)}
            style={{
              backgroundColor: i === index ? "#19BDDE" : "#d0d0d0",
              cursor: "pointer",
              transition: "background 0.3s",
            }}
          />
        ))}
      </div>

      {/* ===== MOBILE SECTION ===== */}
      <div
        className="d-flex d-lg-none flex-column justify-content-center justify-content-md-center align-items-md-center  align-items-center"
        style={{
          width: "100%",
          margin: "0",
          position: "relative",
          gap: "20px",
          padding: "10px",
        }}
      >
        {/* === STACKED IMAGE CARDS === */}
        <div
          className="position-relative"
          style={{
            width: "360px",
            height: "180px",
            borderRadius: "10px",
          }}
        >
          {/* Back card */}
          <img
            src="https://i.ibb.co.com/LdZZtS98/Image-Div-4.png"
            alt="Back Card"
            className="position-absolute rounded "
            style={{
              top: "85px",
              left: "55px",
              minWidth: "65%",

              zIndex: 4,
            }}
          />
          <img
            src="https://i.ibb.co.com/pv0rwhKt/Image-Div-2.png"
            alt="Back Card"
            className="position-absolute rounded "
            style={{
              top: "55px",
              left: "10px",
              minWidth: "65%",
              opacity: "1",
              zIndex: 3,
            }}
          />

          {/* Middle card */}
          <img
            src="https://i.ibb.co.com/tPnxbhX7/Image-Div-1.png"
            alt="Middle Card"
            className="position-absolute rounded "
            style={{
              top: "25px",
              left: "34px",
              minWidth: "75%",
              opacity: "0.7",
              zIndex: 2,
            }}
          />

          {/* Front card */}
          <img
            src="https://i.ibb.co.com/qFPvTqjX/Image-Div-3.png"
            alt="Front Card"
            className="position-absolute rounded "
            style={{
              top: 0,
              left: "65px",
              minWidth: "85%",
              opacity: "0.8",
              zIndex: 1,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "70px",
          }}
        >
          {bannerImages.map((_, i) => (
            <button
              className="d-flex d-md-none"
              key={i}
              onClick={() => setIndex(i)}
              style={{
                width: "30px",
                height: "4px",
                borderRadius: "3px",
                border: "none",
                backgroundColor: i === index ? "#19BDDE" : "#d0d0d0",
                cursor: "pointer",
                transition: "background 0.3s",
              }}
            />
          ))}
        </div>
        {/* === TEXT CONTENT === */}

        <div
          style={{
            border: "1px solid #19BDDE",
            borderRadius: "10px",
            backgroundColor: "#fff",
            maxWidth: "700px",
            padding: "12px",
            marginTop: "10px",
            textAlign: "start",
            boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
          }}
        >
          <h5
            style={{
              fontWeight: "600",
              fontSize: "16px",
              marginBottom: "8px",
              color: "#000",
            }}
          >
            {mobileBannerImages[index].tittle}
          </h5>
          <p
            style={{
              fontSize: "14px",
              color: "gray",
              margin: 0,
              lineHeight: "1.5",
            }}
          >
            {mobileBannerImages[index].des}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileAppBanner;
